import { HpTag, type HpTagTone } from '@hp/ui';
import type { UnitAvailability } from '@hp/domain';
import { useAvailabilityLabel } from './availability-labels';

const TONE: Record<UnitAvailability, HpTagTone> = {
  available: 'success',
  reserved: 'warning',
  sold: 'danger',
};

export function AvailabilityBadge({ availability }: { availability: UnitAvailability }) {
  const label = useAvailabilityLabel();
  return <HpTag tone={TONE[availability]}>{label(availability)}</HpTag>;
}
